module.exports = {
  success: {
    delete_incomplete_uploads: 'Incomplete multipart uploads deleted successfully',
    clear_incomplete_uploads: 'Clearing incomplete multipart uploads is completed. {count} deleted successfully',
    set_versioning: 'Set versioning successfully',
    move_files: '{count} files / folders moved successfully',
    copy_files: '{count} files / folders copyed successfully',
    copy: 'Copy successfully',
    move: 'Move successfully',
    rename: 'Rename successfully',
    edit_public_permission: 'Edit public permission successfully',
    save: 'Save successfully',
    add: 'Added successfully',
    modify: 'Modified successfully',
    delete: 'Deleted successfully',
    copy_path: 'Path copied successfully',
    restore_files: 'Successfully initiated {count} file/folder recovery',
    set: 'Set successfully',
  },

  fail: {
    set_versioning: 'Failed to set versioning',
    delete_incomplete_uploads: 'Failed to delete incomplete mutilpart uploads',
    move_files: 'Failed to move {count} files / folders',
    copy_files: 'Failed to copy {count} files / folders',
    import_files: 'Failed to import {count} files / folders',
    copy: 'Failed to copy',
    move: 'Failed to move',
    rename: 'Failed to rename',
    rename_files: 'Failed to rename {count} files / folders',
    convert_to_encode_param: 'Conversion to {encode} failed',
    save: 'Failed to save',
    restore_files: 'Failed to initiate {count} file/folder recovery',
    get_share_link: 'Failed to get share link. ',
    share: 'Failed to share',
    create_folder: 'Failed to create folder.',
    versioning: 'Failed to modify versioning',
    download_with_restoring: '{storageText} files are restoring, please download files after restoring',
    download_with_no_restore: 'Download failed, please restore the {storageText} file first.',
    restart_cosbrowser: 'Restart failed. Please try again',
    get_website_details: 'Failed to get static website details',
  },
};
